import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_COMBO_USER, GET_CURRENT_USER } from "actions/User/actionTypes";
import {
  getComboUserSuccess,
  getComboUserFailure,
  getCurrentUserFailure,
  getCurrentUserSuccess,
} from "actions/User";
import userApi from "service/userApi";

function* getUserComboData(action) {
  try {
    const response = yield call(userApi.combo, action.dataSearch);
    if (response.data) {
      yield put(getComboUserSuccess(response.data));
    }
  } catch (error) {
    yield put(getComboUserFailure());
  }
}

function* getCurrentUserData(action) {
  try {
    const response = yield call(userApi.getCurrentUser, action.dataSearch);
    if (response.data) {
      yield put(getCurrentUserSuccess(response.data));
    }
  } catch (error) {
    yield put(getCurrentUserFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_COMBO_USER, getUserComboData);
  yield takeLatest(GET_CURRENT_USER, getCurrentUserData);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
